import { useTranslate } from 'react-admin';
import { DOCUMENT_SIDES } from '@/config/constants';

const SIDE_LABEL_KEYS: Record<string, string> = {
  Front: 'fields-mapping.both.side_front',
  Back: 'fields-mapping.both.side_back',
  Both: 'screens.fieldMappings.sideBoth',
};

/** The document sides as choices in the operator's language; `editable` leaves out the generated `Both`. */
export const useDocumentSideChoices = (editable = false) => {
  const t = useTranslate();
  return DOCUMENT_SIDES
    .filter((side) => !editable || side.id !== 'Both')
    .map((side) => ({ id: side.id, name: t(SIDE_LABEL_KEYS[side.id] ?? side.name, { _: side.name }) }));
};
